const minifyGraphQLQuery = (query) => {
  return query.replace(/(\n| )*( |{|})(\n| )*/gm, (_chars, _spaces, brackets) => brackets);
};
export {
  minifyGraphQLQuery
};
//# sourceMappingURL=minifyGraphQLQuery.js.map
